import CreateDisputes from "./createDisputes/CreateDisputes";
import DisputesTable from "./disputesTable/DisputesTable";
import DisputeDetails from "./disputeDetails/DisputeDetails";

export { CreateDisputes, DisputesTable, DisputeDetails };



// WEBPACK FOOTER //
// ./src/components/disputes/index.js